import {
  Component, Input, OnInit,
} from '@angular/core';
import { UpdateMyCourseRequestComponent } from '../my-course-requests/components/update-my-course-request/update-my-course-request.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { EntityService } from 'src/app/services/entity.service';

@Component({
  selector: 'app-my-pd-plan',
  templateUrl: './my-pd-plan.component.html',
  styleUrls: [ './my-pd-plan.component.scss' ],
})
export class MyPdPlanComponent implements OnInit {
  @Input() user: any;
  navTitles = [
    { text: 'My Courses', icon: 'list' },
    // { text: 'Tag Details', icon: 'label' },
    // { text: 'Requirement Summary', icon: 'summarize' },
    // { text: 'Survey Responses', icon: 'poll' },
  ]

  myCoursesTabs = [
    { text: 'Course List View', value: 'courses' },
    { text: 'Requirements View', value: 'requirements' },
  ]




  yearChoices;
  selectedYearChoice;
  selectedTab = this.navTitles[0];
  selectedCoursesTab = this.myCoursesTabs[0].value;
  courses: any;
  entitySubscription: any;
  currentYearId: any;
  disableEditingDueToYear = false;

  constructor(
public dialog: MatDialog, private toast: ToastService, private entityService: EntityService,
  ) { }

  ngOnInit(): void {
    this.entityService.getEntity('Years')
    this.entitySubscription = this.entityService.entityData$.subscribe((entity: any) => {
      if (!entity) return;
      this.currentYearId = entity?.gcCurrentYearId;
      this.yearChoices = entity?.Years?.map((year: any) => {
        return {
          value: year.id,
          text: year.years,
        }
      })
      this.yearChoices = this.yearChoices?.sort((a: any, b: any) => {
        return b.value - a.value;
      })
      this.selectedYearChoice = this.yearChoices?.[0]?.value;
    })
  }

  changeTab = (tab: any) => {
    this.selectedTab = tab;
  }

  changeCoursesTab = (event: Event) => {
    const tab = event.target as HTMLSelectElement;
    this.selectedCoursesTab = tab.value;
  }

  changeYearChoice = (event) => {
    const year = event.target.value
    this.selectedYearChoice = year
    this.disableEditingDueToYear = year !== this.currentYearId;

  }

  toggleCreateModal = () => {
    this.dialog.open(UpdateMyCourseRequestComponent).afterClosed().subscribe((result) => {
      if (result?.statusCode === 1000) {
        this.toast.setToast({
          text: 'Course request submitted successfully',
          type: 'success',
          dismissible: false,
          icon: true,
        })
      }
    })
  }

}
